"use client";

import { useRouter } from "next/router";
import { useEffect } from "react";
import IFeatureFlags from "src/lib/types/IFeatureFlags";

type ScriptOnNavProps = {
    featureFlags?: IFeatureFlags;
    adTargetsIds?: string[];
}

//#region [Component]
export default function ScriptOnNav({ featureFlags, adTargetsIds }: ScriptOnNavProps) {
    return <>
        <AtmngScript />
        <SeenThisScript featureFlags={featureFlags} adTargetsIds={adTargetsIds}/>
    </>
}

function AtmngScript() {
    const router = useRouter();

    useEffect(() => {
        const isStreaming = router.pathname.startsWith('/streamingguide');
        const scriptId = 'atmng-script';

        // Remove existing script if any
        const existing = document.getElementById(scriptId);
        if (existing) {
            existing.remove();
        }

        // Create new script
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = isStreaming
            ? 'https://t.atmng.io/filmweb/IvYQJt7vE.prod.js'
            : 'https://t.atmng.io/filmweb/vqcMX_bYS.prod.js';
        script.async = true;
        script.defer = false;
        document.body.appendChild(script);

        // Optional cleanup if you want to remove it on unmount
        return () => {
            script.remove();
        };
    }, [router.pathname]);

    return null;
}

function SeenThisScript({ featureFlags, adTargetsIds }: ScriptOnNavProps) {
    const router = useRouter();

    useEffect(() => {
        //console.debug("%cSeenThisScript", "color: white; background: red", featureFlags?.executeSeenThisScript, adTargetsIds?.length);
        if (featureFlags?.executeSeenThisScript && (adTargetsIds?.length ?? 0) > 0) {
            console.debug("%cSeenThis", "color: white; background: indigo", adTargetsIds);
            // Create new script
            window.highImpactJs = window.highImpactJs || { cmd: [] };
            window.highImpactJs.cmd.push(() => {
                window.highImpactJs.setConfig({
                    plugins: ['adn'],
                    zIndex: 100000, //Max Z-index on your page
                });
                window.highImpactJs.setTemplateConfig("midscroll", {
                    topBarHeight: 0, // Height in px for the topbar (optional)
                    peekAmount: '100vh', // How much of the ad that should be visible
                    zIndex: 100001, // Z-index for the ad
                });

                const adUnitIdsByTemplate: { [key: string]: string[] } = {
                    midscroll: adTargetsIds!
                };

                const defineSlots = (template: string, sizes: number[][], waitForAdSignal: boolean) => {
                    (adUnitIdsByTemplate[template] || []).forEach(adUnitId => {
                        window.highImpactJs.defineSlot({ template, sizes, adUnitId, waitForAdSignal });
                    });
                };
                defineSlots("midscroll", [[1920, 1080], [1080, 1920]], true);
            });

            const scriptId = 'seenthis-script';
            // Remove existing script if any
            const existing = document.getElementById(scriptId);
            if (existing) {
                existing.remove();
            }

            // Create new script
            const script = document.createElement('script');
            script.id = scriptId;
            script.src = "https://video.seenthis.se/public/patrik/filmweb/high-impact_adnuntius.min.js"
            script.async = true;
            script.defer = false;
            document.head.prepend(script);

            // Optional cleanup if you want to remove it on unmount
            return () => {
                script.remove();
            };
        }
    }, [router.pathname, featureFlags?.executeSeenThisScript, adTargetsIds]);

    return null;


}